import { ChangeDetectorRef, Component } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { Question } from '../../../interfaces/questions.interface';
import { CustomerQuestionnaireService } from '../../../services/customer-questionnaire.service';
import { CommonQuestionnaireService } from '../../../services/common-questionnaire.service';

@Component({
    selector: 'app-overview-progress',
    templateUrl: './overview-progress.component.html',
    styleUrls: ['./overview-progress.component.scss'],
    standalone: false,
})
export class OverviewProgressComponent {
    public numberOfQuestions: number;
    public totalAnswered: number;
    public displayVersion = 'full';

    public questionSubscription: Subscription;
    public displayVersionSubscription: Subscription;

    constructor(
        public customerQuestionnaireService: CustomerQuestionnaireService,
        public commonQuestionnaireService: CommonQuestionnaireService,
        public cdr: ChangeDetectorRef,
    ) {
        this.numberOfQuestions = this.customerQuestionnaireService.calculateTotalNumberOfQuestions();
        this.totalAnswered = this.customerQuestionnaireService.calculateAnsweredQuestions();

        this.customerQuestionnaireService.isQuestionnaireLoaded().subscribe((loaded: boolean) => {
            if (loaded) {
                this.totalAnswered = this.customerQuestionnaireService.calculateAnsweredQuestions();
            }
        });
        this.commonQuestionnaireService.onChoiceChange().subscribe((changeHappened) => {
            this.numberOfQuestions = this.customerQuestionnaireService.calculateTotalNumberOfQuestions();
            this.totalAnswered = this.customerQuestionnaireService.calculateAnsweredQuestions();
            this.cdr.detectChanges();
        });
        this.questionSubscription = this.customerQuestionnaireService.getQuestionObs().subscribe((question: Question | null) => {
            this.numberOfQuestions = this.customerQuestionnaireService.calculateTotalNumberOfQuestions();
            this.totalAnswered = this.customerQuestionnaireService.calculateAnsweredQuestions();
        });

        this.displayVersionSubscription = this.customerQuestionnaireService.getDisplayVersionObs().subscribe((version: string) => {
            this.displayVersion = version;
            this.numberOfQuestions = this.customerQuestionnaireService.calculateTotalNumberOfQuestions();
            this.totalAnswered = this.customerQuestionnaireService.calculateAnsweredQuestions();
        });
    }
}
